import Radium from 'radium';
import { chatAgentBackgroundColor, chatAgentFontColor, userMessageDropShadow } from 'globals/colors';

const indicatorAnimation = Radium.keyframes(
  {
    '10%': {
      transform: 'translateY(-5px)',
      backgroundColor: '#9E9DA2',
    },
    '50%': {
      transform: 'translateY(0)',
      backgroundColor: '#B6B5BA',
    },
  },
  'indicator-animation',
);

const styles = {
  message: {
    fontSize: '12px',
    fontWeight: '400',
    padding: '7px 12px',
    borderRadius: '9px 9px 9px 0',
    display: 'inline-block',
    maxWidth: '250px',
    margin: '0 5px',
    lineHeight: '16px',
    color: chatAgentFontColor,
    backgroundColor: chatAgentBackgroundColor,
    wordWrap: 'break-word',
    boxShadow: `0 0 7px 0 ${userMessageDropShadow}`,
  },
  wrapper: {
    display: 'flex',
    margin: '20px 0',
  },
  emptyAvatar: {
    width: 30,
  },
  userAvatar: {
    margin: 'auto 0 0',
  },
  indicatorOne: {
    animation: '2s ease -1s infinite',
    animationName: indicatorAnimation,
    display: 'inline-block',
    backgroundColor: '#B6B5BA',
    width: '7px',
    height: '7px',
    borderRadius: '100%',
    marginRight: '5px',
    animationDelay: -1,
  },
  indicatorTwo: {
    animation: '2s ease -.85s infinite',
    animationName: indicatorAnimation,
    display: 'inline-block',
    backgroundColor: '#B6B5BA',
    width: '7px',
    height: '7px',
    borderRadius: '100%',
    marginRight: '5px',
    animationDelay: -0.85,
  },
  indicatorThree: {
    animation: '2s ease -.7s infinite',
    animationName: indicatorAnimation,
    display: 'inline-block',
    backgroundColor: '#B6B5BA',
    width: '7px',
    height: '7px',
    borderRadius: '100%',
    marginRight: '5px',
    animationDelay: -0.7,
  },
};

export default styles;
